export default __webpack_public_path__ + "static/media/playtika.58a43384.png";